
import React, {Component} from 'react';
import { connect } from 'react-redux'
import ScaleLoader from "react-spinners/ScaleLoader";

const translator = require('../../utils/translator/translator');

class LoadingComponent extends Component
{
    render()
    {
        if (!this.props.isLoadingRunningLate)
        {
            return <div className='caption primary-color d-flex justify-content-center'>
                        <div style={{marginRight:'5px'}}>
                            {this.props.waitMessage}   
                        </div>                            
                        <div>
                            <ScaleLoader color={"var(--colors-primary)"} height={10} width={4} radius={2} margin={1} loading={true}/>
                        </div>
                    </div>
        }

        return <div className='caption primary-color d-flex align-items-center flex-column'>
                    <div className='caption primary-color d-flex justify-content-center'>
                        <div style={{marginRight:'5px'}}>
                                {this.props.waitMessage}   
                            </div> 
                                                    
                            <div>
                                <ScaleLoader color={"var(--colors-primary)"} height={10} width={4} radius={2} margin={1} loading={true}/>
                            </div>

                            
                        </div>
                    <div className='warn-text' style={{marginTop:'10px'}}>
                            It's taking longer than expected  
                        </div> 
                </div>


    }
}

const mapStateToProps = state => 
{
    return { 
                isLoadingRunningLate: state.isLoadingRunningLate,
           }
}

export default connect(mapStateToProps)(LoadingComponent)